const Footer = () => {
  return (
    <footer
      className="app-footer"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        textAlign: "center",
        fontSize: "0.78rem",
        color: "#64748b",
        padding: "14px 12px 18px",
        margin: "0 auto",
      }}
    >
      © {new Date().getFullYear()} Singhal Group | All Rights Reserved.
    </footer>
  );
};

export default Footer;
